export const actions = {
  CREATE: 'explanation-litmos/create',
  UPDATE: 'explanation-litmos/update',
  CLEAR: 'explanation-litmos/clear',
  UPDATE_PLAYER: 'explanation-litmos/update-player',
};

interface ExplainerAction {
  type:
    | typeof actions.CREATE
    | typeof actions.UPDATE
    | typeof actions.CLEAR
    | typeof actions.UPDATE_PLAYER;
  payload: ExplainerOrNone | PlayerOrNone;
}

type ExplainerActionTypes = ExplainerAction;

const checkBoolean = (bool: boolean | string) => {
  if (bool === 'true') {
    return true;
  }
  return false;
};

export const create = (payload: ExplainerOrNone) => {
  return {
    type: actions.CREATE,
    payload,
  };
};

export const update = (payload: ExplainerOrNone) => {
  return {
    type: actions.UPDATE,
    payload,
  };
};

export const clear = () => {
  return {
    type: actions.CLEAR,
  };
};

export const updatePlayer = (payload: PlayerOrNone) => {
  return {
    type: actions.UPDATE_PLAYER,
    payload,
  };
};

export const stopPlayer = () => {
  return updatePlayer({ playing: false, playedSeconds: 0 });
};

const initialVolume: string | null = localStorage.getItem('volume');
const initialPlayback: string | null = localStorage.getItem('playbackRate');
const initialAdvance: string | null = localStorage.getItem('autoAdvance');
const initialCaptions: string | null = localStorage.getItem('showCaptions');

export const initialState: Explainer = {
  player: {
    playing: true,
    playedSeconds: 0,
    volume: initialVolume ? parseFloat(initialVolume) : 1,
    duration: 0,
    playbackRate: initialPlayback ? parseFloat(initialPlayback) : 1,
    autoAdvance: initialAdvance ? checkBoolean(initialAdvance) : false,
    showCaptions: initialCaptions ? checkBoolean(initialCaptions) : false,
  },
  comments: [],
};

export const explanationLitmosReducer = (
  state = initialState,
  action: ExplainerActionTypes,
): Explainer => {
  switch (action.type) {
    case actions.CREATE:
      return action.payload as Explainer;
    case actions.UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    case actions.UPDATE_PLAYER:
      return {
        ...state,
        player: {
          ...state.player,
          ...action.payload,
        },
      };
    case actions.CLEAR:
      return {
        player: {
          ...state.player,
          playing: true,
          playedSeconds: 0,
          duration: 0,
        },
        comments: [],
      };
    default:
      return state;
  }
};
